/** Created by azhou on 2018/11/30.*/
<template>
  <div :id="mountId"></div>
</template>

<script>
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts')
  // 引入柱状图
  require('echarts/lib/chart/pie');
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')
  export default {
    data () {
      return {}
    },
    props: {
      mountId: {
        type: String,
        default: 'e-pie'
      },
      DataSet: {     //数据集合
        type: Array,
        default () {
          return []
        }
      },
      chartTitle: {
        type: String,
        default: '分类占比统计数据'
      }
    },
    watch: {
      DataSet () {
        this.initEchart()
      }
    },
    mounted () {
      $('#' + this.mountId).css({
        height: $('.e-data').height() * 0.6 + 'px',
      })
      this.initEchart()
    },
    methods: {
      /*初始化echart图表*/
      initEchart () {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init($('#' + this.mountId).get(0))
        let option = {
          title: {
            text: this.chartTitle,
            right: '40px',
            textStyle: {
              color: '#eee',
              fontSize: '16px'
            }
          },
          legend: {
            orient: 'vertical',
            top: 'top',
            left: 'left',
            data: this.DataSet.map(item => item.name),
            textStyle: { color: '#eee' }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          series: [
            {
              name: '类型占比',
              type: 'pie',
              radius: '70%',
              center: ['50%', '50%'],
              data: this.DataSet,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        // 绘制图表
        myChart.setOption(option)
        myChart.off('click')
        myChart.on('click', params => {
          this.$emit('clickPie', params)
        })
      },
    }
  }
</script>
